<template>
  <div>
    <router-link to="/" class="backbutton"
      ><i class="material-icons">arrow_back_ios</i></router-link
    >
    <div class="addblog container">
      <h2>Update It</h2>
      <form autocomplete="off">
        <label for="title">Title <span style="color: red">*</span></label
        ><br />
        <input
          type="text"
          id="title"
          placeholder=""
          v-model="title"
        /><br /><br />
        <label for="img1"
          >Image Link 1 (Main to display on home page)
          <span style="color: red">*</span></label
        ><br />
        <input
          type="text"
          id="img1"
          placeholder=""
          v-model="img1"
        /><br /><br />
        <label for="discription"
          >Discription (Before Image ) <span style="color: red">*</span></label
        >

        <br />
        <vue-editor v-model="disc" id="editor"></vue-editor> <br />

        <label for="img2">Image Link 2</label><br />
        <input
          type="text"
          id="img2"
          placeholder=""
          v-model="img2"
        /><br /><br />

        <label for="discription">Discription (After Image)</label>

        <br />
        <vue-editor v-model="disc2" id="editor"></vue-editor> <br />

        <label for="img3">Image Link 3</label><br />
        <input
          type="text"
          id="img3"
          placeholder=""
          v-model="img3"
        /><br /><br />

        <label for="discription">Discription (Extra discription)</label>

        <br />
        <vue-editor v-model="disc3" id=""></vue-editor> <br />
        <button type="submit" @click.prevent="add" class="addbtn">Update</button
        ><br />
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import firebaseApp from "../firebaseInit";
import { VueEditor } from "vue2-editor";
var db = firebaseApp.firestore();
import "vue-toast-notification/dist/theme-sugar.css";
export default {
  name: "Newpost",
  data() {
    return {
      title: "",
      disc: "",
      disc2: "",
      disc3: "",
      img1: "",
      img2: "",
      img3: "",
      discwords: 0,
      properdisc: false,
    };
  },
  components: {
    VueEditor,
  },
  watch: {
    disc() {
      this.discwords = this.disc.length;
      if (this.discwords > 200) {
        this.properdisc = true;
      } else {
        this.properdisc = false;
      }
    },
  },
  created() {
    this.getdata();
  },
  methods: {
    getdata() {
      db.collection("posts")
        .where(
          firebase.firestore.FieldPath.documentId(),
          "==",
          this.$route.params.title
        )
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.id = doc.id;
            this.title = doc.data().title;
            this.disc = doc.data().disc;
            this.disc2 = doc.data().disc2;
            this.disc3 = doc.data().disc3;
            this.auther = doc.data().auther;
            this.date = doc.data().date;
            this.img1 = doc.data().img;
            this.img2 = doc.data().img2;
            this.img3 = doc.data().img3;
          });
        });
    },

    add() {
      db.collection("posts")
        .doc(this.id)
        .delete()
        .then(() => {
          db.collection("posts")
            .doc(this.id)
            .set({
              title: this.title,
              disc: this.disc,
              disc2: this.disc2,
              disc3: this.disc3,
              img: this.img1,
              img2: this.img2,
              img3: this.img3,
              auther: "Chandra Gangani",
              date: firebase.firestore.FieldValue.serverTimestamp(),
            })
            .then(() => {
              Vue.$toast.open({
                message: "Updated Success...",
                type: "success",
                position: "bottom-left",
              });
              this.$router.replace({ path: "/" });
            })
            .catch((error) => {
              Vue.$toast.error({
                message: error,
                position: "bottom-left",
              });
            });
        })
        .catch((error) => {
          Vue.$toast.error({
            message: error,
          });
        });

      Vue.$toast.open({
        message: "Update it ",
        type: "info",
        position: "bottom-left",
      });
    },
  },
};
</script>

<style scoped>
#editor {
  z-index: -111;
}
.addblog h2 {
  text-align: center;
}
.addblog input {
  font-size: 23px;
  width: 90%;
  padding: 5px;
}
.addblog label {
  font-size: 16px;
}
.backbutton {
  position: fixed;
  z-index: 999;
  padding: 5px;
  margin-left: 4%;
  margin-top: 1rem;
  transition: 0.4s;
}
.addbtn {
  margin-left: 50%;
  transform: translate(-50%, 0%);
  background: transparent;
  color: rgb(0, 0, 0);
  outline: none;
  border: 1px rgba(0, 0, 0, 0.212) solid;
  border-radius: 5px;
  padding: 5px;
  font-size: 15px;
  transition: 0.4s;
  font-weight: 700;
  margin-bottom: 25px;
}
.addbtn:hover {
  background-color: rgb(0, 206, 0);
  color: white;
  border: 1px solid rgba(0, 0, 0, 0);
}
</style>
